import type { IconDefinition } from "@fortawesome/free-regular-svg-icons";
import { faSpinner, faTimes } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import type React from "react";
import { Button, type ButtonProps } from "../Theme/button.tsx";

export interface CancelButtonProps
  extends Omit<ButtonProps, "outline" | "bright" | "plain"> {
  loading?: boolean;
  labelText?: string;
  labelIcon?: IconDefinition;
}

export default function CancelButton(
  props: CancelButtonProps,
): React.ReactElement {
  const {
    loading,
    onClick,
    labelText = "Cancel",
    labelIcon = faTimes,
    color = "red",
    disabled,
    ...rest
  } = props;
  return (
    <Button
      color={color}
      onClick={onClick}
      disabled={loading || disabled}
      {...rest}
    >
      <>
        <FontAwesomeIcon
          icon={loading ? faSpinner : labelIcon}
          fixedWidth
          spin={loading}
        />
        {labelText}
      </>
    </Button>
  );
}
